/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ScriptSection } from './ScriptSection.js';
import {
    ScriptSectionFromJSON,
    ScriptSectionFromJSONTyped,
    ScriptSectionToJSON,
} from './ScriptSection.js';

/**
 * 
 * @export
 * @interface ScriptSectionResponse
 */
export interface ScriptSectionResponse {
    /**
     * 
     * @type {ScriptSection}
     * @memberof ScriptSectionResponse
     */
    data?: ScriptSection;
    /**
     * 
     * @type {number}
     * @memberof ScriptSectionResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof ScriptSectionResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ScriptSectionResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof ScriptSectionResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the ScriptSectionResponse interface.
 */
export function instanceOfScriptSectionResponse(value: object): boolean {
    return true;
}

export function ScriptSectionResponseFromJSON(json: any): ScriptSectionResponse {
    return ScriptSectionResponseFromJSONTyped(json, false);
}

export function ScriptSectionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScriptSectionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ScriptSectionFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ScriptSectionResponseToJSON(value?: ScriptSectionResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ScriptSectionToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

